import Head from "next/head";
import Layout from "../components/Layout";

export default function Refund() {
  return (
    <Layout>
      <Head>
        <title>Refund Policy - AstroLearn</title>
      </Head>
      <section className="p-10 flex flex-col items-center">
        <div className=" max-w-[700px]">
          <div className="py-10">
            <h1>Refund Policy</h1>
            <div className="mt-10 prose">
              <p>
                Please write to us at{" "}
                <a href="mailto: solutions@thefuture.university">
                  solutions@astrolearn.co
                </a>{" "}
                if you want to reach out with a request for refund. However,
                please ensure that you comply to all of the following:
              </p>
              <ul className=" list-disc pl-10 pt-5 flex flex-col gap-2">
                <li>
                  Refund will be credited to the original mode of payment within 3-4 working days.
                </li>
                <li>
                  If you have paid a token amount for the bootcamp, you will not
                  be eligible for a refund for the token amount as this price is
                  paid upfront to block your seat ahead, unless you cancel 14
                  days before the batch start date.
                </li>
                <li>
                  100% refund is possible provided you have not attended any
                  session and cancel 14 days prior to batch start date.
                </li>
                <li>
                  If you cancel your seat between 3-14 days before the batch
                  start date, a 50% refund is possible.
                </li>
                <li>
                  No refund is possible 0-3 days before the batch start date, or
                  once the batch has started.
                </li>
                <li>
                  No refund/cancellation is possible once the course has
                  started.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
